import React, { useState } from 'react';
import {
  Button,
  Col,
  Container,
  Row,
  Spinner
} from 'react-bootstrap';
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';

import useMutation from 'src/Hooks/useMutation';
import { updateSpot } from '../../../Services/api';
import Notification, { useNotification } from 'src/Components/Notification';
import "./style.css";


const InputBoxList = props => {
  const { setStaff, staff, setHasEmailErr } = props;

  const handleAddBox = () => {
    const newBoxes = [...staff, ""];
    setStaff(newBoxes);
  }

  const handleBoxChange = (event, index) => {
    const newBoxes = [...staff];
    newBoxes[index] = event.target.value;
    setHasEmailErr(!validateEmail(event.target.value));
    setStaff(newBoxes);
  }

  const handleDeleteBox = (index) => {
    const newBoxes = [...staff];
    newBoxes.splice(index, 1);
    setStaff(newBoxes);
  }

  const validateEmail = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
  }

  return (
    <div>
      {staff.map((box, index) => (
        <div key={index}>
          <input
            value={box}
            type="email"
            placeholder='Enter email'
            onChange={(event) => handleBoxChange(event, index)}
            className='staffInputBox'
          />
          {(box.trim() !== ""  && staff.length > 1) && (
            <FontAwesomeIcon
              icon={faCircleXmark}
              onClick={() => handleDeleteBox(index)}
              className='delIcon'
            />
          )}
          {(box.length > 1 && !validateEmail(box)) && (
            <small className="text-danger d-block">
              Enter a valid email address
            </small>
          )}
        </div>
      ))}
      <Button
        className='addActionButton'
        onClick={handleAddBox}
        disabled={
          staff[staff.length - 1].trim() === "" || !validateEmail(staff[staff.length - 1])
        }
        variant='link'
      >
        <FontAwesomeIcon
          icon={faCirclePlus}
          className='addIcon'
        />
        <span>Add more</span>
      </Button>
    </div>
  );
}

const AddStaffPage = () => {
  const [managers, setManagers] = useState([""]);
  const [stewards, setStewards] = useState([""]);
  const [hasEmailErr, setHasEmailErr] = useState(false);
  const { id } = useParams();
  const { notifyError, notification, notifySuccess, onClose } = useNotification();

  const { setter: updateStaffAction, loading: updateStaffLoading } = useMutation(updateSpot);

  const addStaff = async () => {
    let data = {};

    if (!emptyManagerArr) {
      data['manager'] = managers.map(item => item.trim()).filter(Boolean);
    }

    if (!emptyStewardArr) {
      data['steward'] = stewards.map(item => item.trim()).filter(Boolean);
    }

    updateStaffAction(
      { id, data },
      () => {
        notifySuccess({ message: "Staff added successfully" });
      },
      () => {
        notifyError({ message: "Error adding staff. Ensure you are providing a valid email and the user is registered." });
      }, 
    ) 
  }

  const emptyManagerArr = managers.filter(item => item !== "").length === 0
  const emptyStewardArr = stewards.filter(item => item !== "").length === 0

  return (
    <Container className="mt-4">
      <Notification id="menu-edit" onClose={onClose} {...notification} />
      <div style={{ paddingBottom: 20, paddingTop: 20 }}>
        <h5 style={{ color: '#333640' }}>New Staff</h5>
      </div>
      <Row>
        <Col xs={12} lg={6} className='contentContainer'>
          <p className='addHeaderText'>Add Manager</p>
          <div className='addManagerContainer'>
            <InputBoxList
              setStaff={setManagers}
              staff={managers}
              setHasEmailErr={setHasEmailErr}
            />
          </div>
        </Col>
        <Col xs={12} lg={6} className='contentContainer'>
          <p className='addHeaderText'>Add Steward</p>
          <div className='addStewardContainer'>
            <InputBoxList
              setStaff={setStewards}
              staff={stewards}
              setHasEmailErr={setHasEmailErr}
            />
          </div>
        </Col>
      </Row>
      <div className='saveBtnContainer'>
        <Button
          className='jamlyfSolidBtn py-2 col-12 col-lg-3 btn fs-6'
          onClick={addStaff}
          disabled={
            (emptyManagerArr && emptyStewardArr) || updateStaffLoading || hasEmailErr
          }
        >
          {updateStaffLoading && (
            <Spinner
              as='span'
              animation='border'
              size='sm'
              role='status'
              aria-hidden='true'
            />
          )}
          <span>Save</span>
        </Button>
      </div>
    </Container>
  );
};


export default AddStaffPage;
